
import generic from '@components/atoms/EditingComponent.vue';
import tween from '@components/editing/tweenEditing.vue'
import text from '@components/editing/textEditing.vue'
import physicsbody2d from '@components/editing/physicsbodyEditing.vue'

export default {
generic,
tween,
physicsbody2d,
text
}
